import React from "react";

function Footer() {
  return (
    <footer className="bg-blue-900 text-white text-center py-6">
      <p>&copy; {new Date().getFullYear()} Navy Residency Girls Hostel, Kota. All rights reserved.</p>
      <p className="text-sm mt-2">Designed with ❤️ for students</p>
    </footer>
  );
}

export default Footer;
